module.exports = __webpack_public_path__ + "static/img/xx.fe4ecbe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teacher/xx.png
// module id = eLhd
// module chunks = 1